// generated by docker build
export var awsPool = {
    "aws_cognito_identity_pool_id": "us-east-1:fc915483-184c-4a6f-8cf3-1f553311e6eb",
    "aws_user_pools_id": "us-east-1_aHLpAt3Bd",
    "aws_user_pools_web_client_id": "4q5a8jm852u2ufiqjk0ls93m09",
};
export var authDomain = "auth-stg.architect-io.com";
export var websiteDomain = "stg.architect-io.com";
